module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Resultado da importação")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.semResultado) ? _c('div', {
    staticClass: "resultado-estatísticas-importacao-csv m-b-lg"
  }, [_c('div', [_vm._v("Total enviado: "), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('div', [_vm._v("Grvs inválidas: "), _c('span', [_vm._v(_vm._s(_vm.quantidadeGrvsInvalidas) + " (" + _vm._s(_vm.porcentagemInvalidas) + "%)")])]), _vm._v(" "), _c('div', [_vm._v("Grvs não encontradas: "), _c('span', [_vm._v(_vm._s(_vm.quantidadeGrvsNaoEncontradas) + " (" + _vm._s(_vm.porcentagemNaoEncontradas) + "%)")])]), _vm._v(" "), _c('div', [_vm._v("Efetividade: "), _c('span', {
    class: _vm.porcentagemEfetividade.class
  }, [_vm._v(_vm._s(_vm.porcentagemEfetividade.valor) + "%")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.semResultado) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Leilão não foi gerado via importação csv de Grvs!")])]) : (parseInt(_vm.porcentagemEfetividade.valor) === 100) ? _c('div', {
    staticClass: "text-success resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Todos as Grvs foram encontradas!")])]) : _c('div', {
    staticClass: "resultado-estatísticas-importacao-csv"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "txt-placas-invalidas"
    }
  }, [_vm._v("Grvs inválidas:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grvsInvalidasFormatado),
      expression: "grvsInvalidasFormatado"
    }],
    staticClass: "form-control",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "id": "txt-placas-invalidas",
      "cols": "30",
      "rows": "10",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.grvsInvalidasFormatado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grvsInvalidasFormatado = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "txt-placas-nao-encontradas"
    }
  }, [_vm._v("Grvs não encontradas: "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "A placa não foi encontrada no sistema, ou não está com status 'no pátio'"
    }
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grvsNaoEncontradasFormatado),
      expression: "grvsNaoEncontradasFormatado"
    }],
    staticClass: "form-control",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "id": "txt-placas-nao-encontradas",
      "cols": "30",
      "rows": "10",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.grvsNaoEncontradasFormatado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grvsNaoEncontradasFormatado = $event.target.value
      }
    }
  })])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-945a18ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/ResultadoImportacaoCsvGrv.vue
// module id = 1988
// module chunks = 20